<template>
  <div id="app">
    <app-header></app-header>
      <transition name="fade" mode="out-in" appear>
        <router-view></router-view>
      </transition>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/Header/Index';
import AppFooter from '@/components/Footer/Index';

export default {
  name: 'app',
  components: {
    AppHeader, AppFooter,
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

<style src="assets/stylesheets/index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?e2e71698